import { __read } from "tslib";
import { logGenericEvent } from '@office-start/instrumentation-service';
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { getIsPageVisible } from '@office-start/page-visibility-service';
import { mark } from '@office-start/performance-service';
import { IDLE_VERYLOW_PRIORITY, scheduleWork, } from '@office-start/scheduler-service';
import { logFeature } from '@office-start/telemetry-service';
import { useEffect, useRef } from 'react';
import { logEdgeworthImpression } from '../logEdgeworthImpression';
export function useEdgeworthInstrumentation(_a) {
    var documents = _a.documents, bridgeData = _a.bridgeData, canRender = _a.canRender, isError = _a.isError, isInitialStable = _a.isInitialStable, paintMarker = _a.paintMarker, instrumentationArea = _a.instrumentationArea;
    var isInitialImpressionLogged = useRef(false);
    var isInitialFullImpressionLogged = useRef(false);
    var isPaintMarkerRecorded = useRef(false);
    var isErrorLogged = useRef(false);
    useEffect(function () {
        if (canRender) {
            if (isError && !isErrorLogged.current) {
                logFeature({
                    featureName: "Edgeworth" /* KnownFeatureNames.Edgeworth */,
                    eventName: 'Edgeworth_Error',
                    area: instrumentationArea,
                });
                isErrorLogged.current = true;
            }
            else if (isInitialStable &&
                !isInitialFullImpressionLogged.current) {
                // During initial page load, partial impression (showing initial items from cache or Recent API) typically happens first before full impression,
                // but when switching routes, we would immediately render full impression, so we don't need to log impression twice.
                scheduleWork(function () {
                    logEdgeworthImpression({
                        documents: documents,
                        logDistribution: true,
                        instrumentationArea: instrumentationArea,
                    });
                }, IDLE_VERYLOW_PRIORITY);
                isInitialFullImpressionLogged.current = true;
                isInitialImpressionLogged.current = true;
            }
            else if (!isInitialImpressionLogged.current) {
                logEdgeworthImpression({
                    documents: documents,
                    instrumentationArea: instrumentationArea,
                });
                isInitialImpressionLogged.current = true;
            }
            if (!isPaintMarkerRecorded.current) {
                if (getIsPageVisible()) {
                    mark(paintMarker);
                }
                isPaintMarkerRecorded.current = true;
            }
        }
    }, [
        documents,
        isInitialStable,
        canRender,
        paintMarker,
        instrumentationArea,
        isError,
    ]);
    // Instrument cache read here as long as preloaded data is being passed as prop
    // This is temporary until we move to a full React SPA and doing prefetch within context of React itself
    useEffect(function () {
        if (bridgeData &&
            bridgeData.preloadedCacheEntries &&
            bridgeData.preloadDuration) {
            var params_1 = {};
            params_1['Area'] = instrumentationArea;
            Promise.all([
                bridgeData.preloadedCacheEntries,
                bridgeData.preloadDuration,
            ])
                .then(function (res) {
                var _a = __read(res, 2), cacheEntries = _a[0], duration = _a[1];
                params_1['State'] = 'Succeeded';
                params_1['ActualSize'] = ((cacheEntries === null || cacheEntries === void 0 ? void 0 : cacheEntries.length) || 0).toString();
                params_1['Latency'] = duration.toString() || '';
            })
                .catch(function (error) {
                var _a;
                params_1['State'] = 'Failed';
                params_1['Error'] = ((_a = error === null || error === void 0 ? void 0 : error.toString) === null || _a === void 0 ? void 0 : _a.call(error)) || '';
            })
                .then(function () {
                logGenericEvent(KnownInstrumentationEvents.EdgeworthCacheRead, params_1);
                // TODO: Remove above Aria logging after fully migrating to OTEL
                logFeature({
                    featureName: "Edgeworth" /* KnownFeatureNames.Edgeworth */,
                    eventName: 'EdgeworthCacheRead',
                    params: params_1,
                    area: instrumentationArea,
                });
            });
        }
    }, [bridgeData, instrumentationArea]);
}
//# sourceMappingURL=useEdgeworthInstrumentation.js.map